import { fetchClientSyncStatus, type ClientSyncProgress } from '../api/clientes';
import { useJobProgress } from './useJobProgress';

/**
 * Progresso da sincronização de clientes em tempo real (SSE com retry e fallback de polling
 * em GET /clientes/sync/status — ver {@link useJobProgress}).
 *
 * @param enabled - Se true, conecta ao stream SSE. Se false, desconecta.
 * @returns O estado atual do progresso ou null se inativo/desconectado.
 */
export function useClientSyncProgress(enabled: boolean): ClientSyncProgress | null {
  return useJobProgress<ClientSyncProgress>(enabled, '/clientes/sync/stream', fetchClientSyncStatus);
}
